export default function SettingsDevicesPage() {
  return <div>SettingsDevicesPage</div>;
}
